<div mat-dialog-content>
    <div class="controlPanel-container-button">
        <button mat-icon-button (click)="onClose()">
            <mat-icon>clear</mat-icon>
        </button>
    </div>
    <app-conControlPanelNew (closeDialog)="onClose()" [controlPanelId]="controlPanelId"></app-conControlPanelNew>
</div>